import { render, staticRenderFns } from "./ResultCompatibiliteVReverse.vue?vue&type=template&id=770923a0&"
import script from "./ResultCompatibiliteVReverse.vue?vue&type=script&lang=js&"
export * from "./ResultCompatibiliteVReverse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports